import React from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import { LanguageProvider } from './context/LanguageContext';
import Landing from './components/Landing';
import Footer from './components/Footer';
import ContactForm from './components/ContactForm';
import Dashboard from './components/Dashboard';
import CRM from './components/CRM';
import Navbar from './components/Navbar';
import Login from './components/Login';
import PrivateRoute from './components/PrivateRoute';
import Register from './components/Register';
import AdminDashboard from './components/AdminDashboard';
import CreateTestUser from './components/dashboard/CreateTestUser';
import DashboardV2 from './components/dashboard-v2/DashboardV2';

function AppContent() {
  const location = useLocation();
  
  // Dashboard, admin, and CRM pages should hide the public website's header/footer
  const isDashboardOrCrm = 
    location.pathname.startsWith('/dashboard') || 
    location.pathname === '/admin' || 
    location.pathname === '/crm';

  return (
    <div className="flex flex-col min-h-screen">
      {!isDashboardOrCrm && <Navbar />}
      <main className="flex-grow pt-0">
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="/register" element={<Register />} />
          <Route path="/setup-test-users" element={<CreateTestUser />} />
          <Route path="/" element={<Landing />} />
          <Route path="/contact" element={<ContactForm />} />
          <Route
            path="/dashboard"
            element={
              <PrivateRoute>
                <Dashboard />
              </PrivateRoute>
            }
          />
          <Route
            path="/dashboard-v2"
            element={
              <PrivateRoute>
                <DashboardV2 />
              </PrivateRoute>
            }
          />
          <Route path="/crm" element={<CRM />} />
          <Route path="/admin" element={<AdminDashboard />} />
        </Routes>
      </main>
      {!isDashboardOrCrm && <Footer />}
    </div>
  );
}

function App() {

  return (
    <Router>
      <LanguageProvider>
        <AppContent />
      </LanguageProvider>
    </Router>
  );
}

export default App;